import React from "react"
import PropTypes from "prop-types"

import EmptyCard from "../Card"
import {lightCyan} from "../styled/Card/colors"
import createAPoll from "../../../../images/createAPoll.svg"

const CreateAPoll = ({onClick}) => (
  <EmptyCard
    title="recognition.polls.empty.card.createPoll.title"
    desc="recognition.polls.empty.card.createPoll.desc"
    img={createAPoll}
    color={lightCyan}
    onClick={onClick}
  />
)

CreateAPoll.propTypes = {
  onClick: PropTypes.func.isRequired
}

export default CreateAPoll
